module.exports = __webpack_public_path__ + "static/media/tds.0816b675.png";